import { Reducer, Action } from 'redux';
import { DashboardAdminListState } from './types-store';
import {
  ACTION, ClearList,
  RequestList, ReceiveList, FailList,
  RequestDeleteDashboard, ReceiveDeleteDashboard, FailDeleteDashboard
} from './action-types';

export const INITIAL_STATE: DashboardAdminListState = {
  requestId: 0,
  fetching: false,
  requestedSearchModel: undefined,
  numberOfResults: undefined,
  listItems: undefined,
  deletingDashboards: []
};

const reducers: { [indexer: string]: Reducer<DashboardAdminListState, Action> } = {

  [ACTION.CLEAR_LIST]: (state: DashboardAdminListState, action: ClearList): DashboardAdminListState => {
    return {
      ...state,
      requestId: action.requestId,
      fetching: false,
      requestedSearchModel: undefined,
      numberOfResults: undefined,
      listItems: undefined,
      deletingDashboards: []
    };
  },

  [ACTION.REQUEST_LIST]: (state: DashboardAdminListState, action: RequestList): DashboardAdminListState => {

    return {
      ...state,
      requestId: action.requestId,
      fetching: true,
      requestedSearchModel: action.model,
      ...(action.clearResults && {
        numberOfResults: undefined,
        listItems: undefined,
        deletingDashboards: []
      })
    };
  },

  [ACTION.RECEIVE_LIST]: (state: DashboardAdminListState, action: ReceiveList): DashboardAdminListState => {

    if (action.requestId !== state.requestId) {
      return state;
    }

    return {
      ...state,
      fetching: false,
      numberOfResults: action.numberOfResults,
      listItems: [
        ...(state.listItems || []),
        ...action.list
      ]
    };
  },

  [ACTION.FAIL_LIST]: (state: DashboardAdminListState, action: FailList): DashboardAdminListState => {

    if (action.requestId !== state.requestId) {
      return state;
    }

    return {
      ...state,
      fetching: false
    };
  },

  [ACTION.REQUEST_DELETE_DASHBOARD]: (state: DashboardAdminListState, action: RequestDeleteDashboard): DashboardAdminListState => {

    return !state.deletingDashboards || !state.deletingDashboards.includes(action.id)
      ? {
        ...state,
        deletingDashboards: [
          ...(state.deletingDashboards || []),
          action.id
        ]
      }
      : state;
  },

  [ACTION.RECEIVE_DELETE_DASHBOARD]: (state: DashboardAdminListState, action: ReceiveDeleteDashboard): DashboardAdminListState => {

    if (!state.deletingDashboards || !state.deletingDashboards.includes(action.id) || !state.listItems?.length) {
      return state;
    }

    const listItems = (state.listItems || []).filter(item => item.code.value !== action.id);

    return {
      ...state,
      listItems,
      numberOfResults: state.numberOfResults - (state.listItems.length - listItems.length),
      deletingDashboards: state.deletingDashboards.filter(id => id !== action.id)
    };
  },

  [ACTION.FAIL_DELETE_DASHBOARD]: (state: DashboardAdminListState, action: FailDeleteDashboard): DashboardAdminListState => {

    return state.deletingDashboards && state.deletingDashboards.includes(action.id)
      ? {
        ...state,
        deletingDashboards: state.deletingDashboards.filter(id => id !== action.id)
      }
      : state;
  }
};

export const reducer: Reducer<DashboardAdminListState> = (
  state: DashboardAdminListState = INITIAL_STATE, action: Action) => {
  const r = reducers[action.type];
  return (r && r(state, action)) || state;
};
